<template>
  <div class="template-admin">
    <v-card>
      <v-card-title data-cy="title">
        Templates
        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          :prepend-icon="svgMagnify"
          label="Search"
          clearable
          style="margin-left:250px;"
        ></v-text-field>
      </v-card-title>

      <!-- ************************* -->
      <v-card-actions class="mb-1">
        <v-spacer></v-spacer>
        <v-btn data-cy="plus-btn" text @click="addTemplate()">
          <v-icon>
            {{ svgPlus }}
          </v-icon>
        </v-btn>
      </v-card-actions>

      <v-data-table :headers="headers" :items="items" :search="search" :items-per-page="5" class="elevation-1">
        <template v-slot:item.action="{ item }">
          <v-icon @click="editItem(item)">
            {{ svgPencil }}
          </v-icon>
          <v-icon @click="deleteItem(item)">
            {{ svgDelete }}
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card v-if="selectedTemplate">
        <v-card-title class="text-h5 grey lighten-2" primary-title> Delete - {{ selectedTemplate.name }} </v-card-title>

        <v-card-text>
          Press OK to delete this template.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteTemplate()">OK</v-btn>
          <v-btn color="primary" text @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mdiPencil, mdiDelete, mdiMagnify, mdiPlus } from "@mdi/js";

export default {
  name: "Templates",
  components: {},
  data: () => {
    return {
      search: "",
      svgPlus: mdiPlus,
      svgMagnify: mdiMagnify,
      svgPencil: mdiPencil,
      svgDelete: mdiDelete,
      dialog: false,
      selectedTemplate: null,
      pagination: {
        sortBy: "name",
        descending: true,
        rowsPerPage: 5,
      },
      headers: [
        { text: "ID", value: "id" },
        {
          text: "Templates",
          align: "left",
          value: "name",
          "must-sort": true,
        },
        {
          text: "Description",
          align: "left",
          value: "description",
          "must-sort": true,
        },
        { text: "Action", value: "action", sortable: false, width: "10%" },
      ],
    };
  },
  created() {
    this.$store.dispatch("getTemplatesList");
  },
  computed: {
    ...mapGetters({
      items: "getTemplatesList",
    }),
  },
  methods: {
    addTemplate() {
      this.$store.dispatch("selectedTemplate", null);
      this.$router.push({ name: "TemplatesDetails" });
    },
    editItem(item) {
      if (!item) {
        return;
      }
      this.selectedTemplate = item;
      this.$store.dispatch("selectedTemplate", item);
      this.$router.push({ name: "TemplatesDetails" });
    },
    deleteItem(item) {
      if (!item) {
        return;
      }
      this.selectedTemplate = item;
      this.dialog = true;
    },
    deleteTemplate() {
      this.dialog = false;
      if (!this.selectedTemplate) {
        return;
      }
      this.$store.dispatch("deleteTemplate", this.selectedTemplate);
    },
  },
};
</script>

<style lang="scss">
.template-admin {
}
</style>
